export default {"src":"/_next/static/media/0x078fb926b041a816facced3614cf1e4bc3c723bd.fd49445d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};